<template>
<div v-if="1 === 1">
	<div v-for="poll in polls" :key="poll.id">
		<div class="polls">
			<div class="poll poll--fullsize">
				<div class="poll__content">
					<div class="poll__header">
						<h2>{{ poll.name }}</h2>
					</div>
					<div class="poll__body">
						<div v-for="question in poll.questions" :key="question.id" v-if="poll.questions">
							<div v-if="question.options">
								<doug-chart :chart-id="String(question.id)" :chart-data="chartData(question)" v-if="question.options[0].count > 0 || question.options[1].count > 0"></doug-chart>
								<p class="empty-state__box" v-else>
									{{ 'no-poll-information' | translate | capitalize }}
								</p>
							</div>
							<p class="poll__body__question">
								{{ question.content }}
							</p>
							<p class="poll__body__time" v-if="poll.active_time">
								{{ 'active-time-poll' | translate | capitalize }}
								{{ poll.active_time }}
								{{ (poll.active_time > 1 ) ? 'days': 'day' | translate | lowercase }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<pagination
		:classNames="'pagination-arrows pull-right'"
		dispatchToCall="getPolls"
		:itemsPerPageProp="session.results"
		:totalItensPagesProps="totalPages"
		:totalItens="totalItems"
		:totalPagesProp="totalPages"
	></pagination>
</div>
<div v-else>
	<div class="content-empty">
		<p class="empty-state">
			{{ 'no-active-poll' | translate | capitalize }}
		</p>
	</div>
</div>

</template>
<script>

import pagination from '../../components/pagination/pagination.vue';
import DougChart from '../../components/charts/DougChart';

export default {
	name: 'listPolls',
	components: {
		pagination,
		DougChart,
	},
	data() {
		return {
			show: true,
			status_id: 1,
			loading: false,
			session: {
				page: 1,
				results: 20,
				apiKey: sessionStorage.getItem('apiKey'),
				userId: sessionStorage.getItem('userId'),
			},
			dataCollectionPollSelect: {},
		};
	},
	computed: {
		polls() {
			return this.$store.state.poll.polls.polls;
		},
		totalItems() {
			return this.$store.state.poll.polls.total || 0;
		},
		totalPages: {
			get() {
				return this.totalItems / this.session.results || 0;
			},
			set() {
			},
		},
	},
	methods: {
		toggleLoading() {
			this.loading = !this.loading;
		},
		chartData(question) {
			const dataChart = {
				datasets: [{
					data: [question.options[0].count, question.options[1].count],
					backgroundColor: [
						'rgb(174, 150, 187)',
						'rgb(247, 218, 103)',
					],
				}],
				labels: [question.options[0].content, question.options[1].content],
			};
			return dataChart;
		},
	},
	mounted() {
		this.$store.dispatch('getPolls', this.session)
			.then(() => {
				this.toggleLoading();
			})
			.catch(() => {
				this.toggleLoading();
			});
	},
};
</script>




// WEBPACK FOOTER //
// _source/javascripts/modules/poll/listPolls.vue